import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Currency } from '../../../../shared/models/currency';
import {
  buildIssueCurrencyPickerModel,
  resolveIssueCurrencyId,
} from './budget-issue-currency-picker.utils';

export interface BudgetIssueCurrencyPickerData {
  currencies: Currency[];
  budgetCurrencyId: number | string | null | undefined;
}

@Component({
  selector: 'app-budget-issue-currency-picker',
  standalone: false,
  templateUrl: './budget-issue-currency-picker.component.html',
  styleUrls: ['./budget-issue-currency-picker.component.less'],
})
export class BudgetIssueCurrencyPickerComponent {
  private readonly data = inject<BudgetIssueCurrencyPickerData>(NZ_MODAL_DATA);
  private readonly modalRef = inject<NzModalRef<BudgetIssueCurrencyPickerComponent>>(NzModalRef);
  readonly model = buildIssueCurrencyPickerModel(this.data.currencies, this.data.budgetCurrencyId);
  selectedId: number | null = this.model.selectedId;

  /** Chosen currency to send, or undefined when the budget currency is kept. */
  get issueCurrencyId(): number | undefined {
    return resolveIssueCurrencyId(this.selectedId, this.data.budgetCurrencyId);
  }

  /** Runs the modal's nzOnOk with this picker, which closes the modal afterwards. */
  generate(): void {
    this.modalRef.triggerOk();
  }

  cancel(): void {
    this.modalRef.close();
  }
}

/** Opens the picker; `onGenerate` runs only on "Generar", so cancelling sends no request. */
export function openBudgetIssueCurrencyPicker(
  modalService: NzModalService,
  data: BudgetIssueCurrencyPickerData,
  onGenerate: (issueCurrencyId: number | undefined) => void
): void {
  // Same shell as the drawer's other modals: the picker draws its own header and footer.
  modalService.create<BudgetIssueCurrencyPickerComponent, BudgetIssueCurrencyPickerData>({
    nzTitle: undefined,
    nzContent: BudgetIssueCurrencyPickerComponent,
    nzData: data,
    nzFooter: null,
    nzClosable: false,
    nzCentered: true,
    nzWidth: 518,
    // Without this the search input takes focus on open and greys out the selected value.
    nzAutofocus: null,
    nzOnOk: (picker) => onGenerate(picker.issueCurrencyId),
  });
}
